<template>
  <div
    class="space-y-3"
    role="status"
    :aria-label="ariaLabel"
  >
    <div class="flex flex-wrap gap-2">
      <span
        v-for="n in 4"
        :key="`chip-skel-${n}`"
        class="h-7 rounded-lg bg-slate-200 dark:bg-slate-700 animate-pulse"
        :class="n === 1 ? 'w-24' : n === 2 ? 'w-20' : n === 3 ? 'w-28' : 'w-16'"
      ></span>
    </div>

    <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
      <div
        v-for="n in 2"
        :key="`field-skel-${n}`"
        class="flex items-start gap-2"
      >
        <span
          class="w-4 h-4 rounded bg-slate-200 dark:bg-slate-700 animate-pulse shrink-0 mt-0.5"
        ></span>
        <div class="flex-1 space-y-2">
          <span
            class="block h-3 w-16 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
          ></span>
          <span
            class="block h-4 w-full max-w-[12rem] rounded bg-slate-100 dark:bg-slate-800 animate-pulse"
          ></span>
        </div>
      </div>
    </div>

    <div class="flex items-start gap-2">
      <span
        class="w-4 h-4 rounded bg-slate-200 dark:bg-slate-700 animate-pulse shrink-0 mt-0.5"
      ></span>
      <div class="flex-1 space-y-2">
        <span
          class="block h-3 w-20 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
        ></span>
        <span
          class="block h-16 w-full rounded-xl bg-slate-100 dark:bg-slate-800 animate-pulse"
        ></span>
      </div>
    </div>

    <div
      class="p-3 rounded-xl border border-slate-200/80 dark:border-slate-700/80 space-y-3"
    >
      <span
        class="block h-3 w-28 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
      ></span>
      <span
        v-for="n in 2"
        :key="`client-skel-${n}`"
        class="block h-3 w-full rounded bg-slate-100 dark:bg-slate-800 animate-pulse"
      ></span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  ariaLabel: { type: String, default: "Loading" },
});
</script>
